(function () {
  'use strict';

  var root = document.querySelector('[data-woodarq-cart-drawer]');
  if (!root || root.dataset.woodarqCartReady === 'true') return;
  root.dataset.woodarqCartReady = 'true';

  var drawer = root.querySelector('.woodarq-cart-drawer');
  var backdrop = root.querySelector('.mini-cart-global-backdrop');
  var trigger = root.querySelector('#mini-cart-trigger');
  var closeButton = root.querySelector('#mini-cart-close');
  var itemsContainer = root.querySelector('[data-woodarq-cart-items]');
  var recommendationsSection = root.querySelector('[data-woodarq-cart-recommendations]');
  var recommendationsTrack = root.querySelector('[data-woodarq-cart-recommendations-track]');
  var recommendationsPrevious = root.querySelector('[data-woodarq-cart-recommendations-previous]');
  var recommendationsNext = root.querySelector('[data-woodarq-cart-recommendations-next]');
  var addonModal = root.querySelector('[data-woodarq-cart-addon-modal]');
  var addonForm = root.querySelector('[data-woodarq-cart-addon-form]');
  var addonTitle = root.querySelector('[data-woodarq-cart-addon-title]');
  var addonPrice = root.querySelector('[data-woodarq-cart-addon-price]');
  var addonImageWrap = root.querySelector('[data-woodarq-cart-addon-image-wrap]');
  var addonOptions = root.querySelector('[data-woodarq-cart-addon-options]');
  var addonQuantity = root.querySelector('[data-woodarq-cart-addon-quantity]');
  var addonSubmit = root.querySelector('[data-woodarq-cart-addon-submit]');
  var addonAvailability = root.querySelector('[data-woodarq-cart-addon-availability]');
  var protectionRow = root.querySelector('[data-woodarq-cart-protection]');
  var protectionPrice = root.querySelector('[data-woodarq-cart-protection-price]');
  var checkoutForm = root.querySelector('.mini-cart-checkout-form');
  var checkoutButton = root.querySelector('.mini-cart-checkout-btn');
  var checkoutWithoutButton = root.querySelector('[data-woodarq-cart-checkout-without]');
  var checkoutLabel = root.querySelector('[data-woodarq-cart-checkout-label]');
  var checkoutLock = root.querySelector('[data-woodarq-cart-checkout-lock]');
  var checkoutError = root.querySelector('[data-woodarq-cart-checkout-error]');
  var loadingBackground = root.querySelector('.loading-bg');
  var statusNode = root.querySelector('[data-woodarq-cart-status]');
  var sectionId = root.dataset.sectionId || 'header';
  var moneyFormat = root.dataset.moneyFormat || (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var protectionProductId = '';
  var protectionVariantSet = new Set();
  var protectionTiers = [];
  var recommendationData = extractRecommendationData(root);
  var currentCart = null;
  var refreshTimer = null;
  var refreshPromise = null;
  var refreshAgain = false;
  var reloadRecommendationsNext = false;
  var busyCount = 0;
  var checkingOut = false;
  var wasOpen = false;
  var lockedScrollY = null;
  var previousBodyTop = '';
  var renderedRecommendations = new Map();
  var activeAddonProduct = null;
  var activeAddonVariant = null;
  var addonReturnFocus = null;

  readProtectionProduct(root);

  function route(path) {
    return shopRoot.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var match = moneyFormat.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';

    function withDelimiters(amount, precision, thousands, decimal) {
      var number = (amount / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var formatted;
    switch (placeholder) {
      case 'amount_no_decimals':
        formatted = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(value, 0, '.', ',');
        break;
      default:
        formatted = withDelimiters(value, 2, ',', '.');
        break;
    }

    return match ? moneyFormat.replace(placeholderRegex, formatted) : '$' + formatted;
  }

  function extractRecommendationData(context) {
    var sources = new Map();
    if (!context) return sources;

    context.querySelectorAll('[data-woodarq-cart-recommendation-source]').forEach(function (source) {
      var sourceProductId = String(source.dataset.sourceProductId || '');
      var products = sources.get(sourceProductId) || [];

      source.querySelectorAll('[data-woodarq-cart-recommendation]').forEach(function (node) {
        try {
          var product = JSON.parse(node.textContent || '{}');
          product.id = String(product.id || '');
          product.title = product.title || '';
          product.url = product.url || '#';
          product.image = product.image || '';
          product.options = Array.isArray(product.options) ? product.options : [];
          product.variants = (Array.isArray(product.variants) ? product.variants : []).map(function (variant) {
            return {
              id: String(variant.id || ''),
              title: variant.title || '',
              available: Boolean(variant.available),
              price: Number(variant.price || 0),
              options: Array.isArray(variant.options) ? variant.options : [],
              image: variant.image || product.image
            };
          });
          products.push(product);
        } catch (error) {
          console.warn('Woodarq cart drawer: could not parse a recommended product.', error);
        }
      });

      sources.set(sourceProductId, products);
    });

    return sources;
  }

  function setProtectionProduct(product) {
    if (!product || !product.id || !Array.isArray(product.variants)) {
      throw new Error('Package protection is unavailable. Please choose checkout without package protection.');
    }

    protectionProductId = String(product.id);
    protectionTiers = product.variants.map(function (variant) {
      // Keep every variant recognizable for opt-out, including unparseable or retired tiers.
      protectionVariantSet.add(String(variant.id));
      // "Greather" is a spelling already used by the shipping-protection product.
      var match = String(variant.title || '').trim().match(/^(less|greater|greather)\s+than\s+\$?\s*(\d+(?:,\d{3})*(?:\.\d{1,2})?)$/i);
      if (!match) return null;
      return {
        id: String(variant.id),
        direction: match[1].toLowerCase() === 'less' ? 'less' : 'greater',
        threshold: Math.round(Number(match[2].replace(/,/g, '')) * 100),
        price: Number(variant.price),
        available: Boolean(variant.available)
      };
    }).filter(Boolean).sort(function (left, right) {
      return left.threshold - right.threshold;
    });
  }

  function readProtectionProduct(context) {
    var source = context.querySelector('[data-woodarq-cart-protection-product]');
    try {
      setProtectionProduct(JSON.parse(source ? source.textContent : 'null'));
    } catch (error) {
      console.warn('Woodarq cart drawer: could not read shipping protection.', error);
    }
  }

  async function loadProtectionProduct() {
    var handle = root.dataset.protectionProductHandle;
    if (!handle) throw new Error('Package protection is unavailable. Please choose checkout without package protection.');
    var response = await window.fetch(route('products/' + encodeURIComponent(handle) + '.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    setProtectionProduct(await parseJsonResponse(response));
  }

  function getProtectionTier(subtotal) {
    // The highest matching "Greater Than" threshold wins, regardless of variant order.
    var greaterTiers = protectionTiers.filter(function (tier) { return tier.direction === 'greater'; });
    var tier = greaterTiers.slice().reverse().find(function (candidate) {
      return subtotal > candidate.threshold;
    }) || protectionTiers.find(function (candidate) {
      if (candidate.direction !== 'less') return false;
      // Preserve the existing boundary: $100 moves up, but $1,000 stays in the lower tier.
      return subtotal < candidate.threshold || (subtotal === candidate.threshold && greaterTiers.some(function (greater) {
        return greater.threshold === candidate.threshold;
      }));
    });
    // An unavailable tier must not fall back to a cheaper protection variant.
    return tier && tier.available ? tier : null;
  }

  function isProtectionItem(item) {
    return (protectionProductId && String(item.product_id) === protectionProductId) ||
      protectionVariantSet.has(String(item.variant_id)) ||
      Boolean(item.properties && item.properties._woodarq_shipping_protection === 'true');
  }

  function getMerchandiseItems(cart) {
    return (cart && cart.items ? cart.items : []).filter(function (item) {
      return !isProtectionItem(item);
    });
  }

  function getMerchandiseSubtotal(cart) {
    return getMerchandiseItems(cart).reduce(function (sum, item) {
      return sum + Number(item.final_line_price == null ? item.line_price : item.final_line_price);
    }, 0);
  }

  function getVisibleItemCount(cart) {
    return getMerchandiseItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  async function parseJsonResponse(response) {
    var data;
    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      throw new Error((data && (data.description || data.message)) || 'Unable to update the cart.');
    }

    return data;
  }

  async function fetchCart() {
    var response = await window.fetch(route('cart.js'), {
      headers: { Accept: 'application/json' }
    });
    return parseJsonResponse(response);
  }

  async function changeCartItem(key, quantity) {
    var response = await window.fetch(route('cart/change.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Woodarq-Cart-Drawer': '1'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    return parseJsonResponse(response);
  }

  async function addCartVariant(variantId, properties, quantity) {
    var item = {
      id: Number(variantId),
      quantity: Math.max(1, Number(quantity) || 1)
    };

    if (properties) item.properties = properties;

    var response = await window.fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Woodarq-Cart-Drawer': '1'
      },
      body: JSON.stringify({ items: [item] })
    });
    return parseJsonResponse(response);
  }

  async function loadRecommendationData() {
    var sectionUrl = route('?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now());
    var response = await window.fetch(sectionUrl, {
      headers: { Accept: 'text/html' }
    });
    if (!response.ok) return;

    var html = await response.text();
    var documentFragment = new DOMParser().parseFromString(html, 'text/html');
    var nextRoot = documentFragment.querySelector('[data-woodarq-cart-drawer]');
    if (nextRoot) {
      recommendationData = extractRecommendationData(nextRoot);
      readProtectionProduct(nextRoot);
    }
  }

  function setBusy(isBusy) {
    busyCount = Math.max(0, busyCount + (isBusy ? 1 : -1));
    var busy = checkingOut || busyCount > 0;
    if (loadingBackground) loadingBackground.classList.toggle('loading-bg_active', busy);
    root.querySelectorAll('button, input, select').forEach(function (control) {
      if (control === trigger || control === closeButton) return;
      control.disabled = busy || ((control === checkoutButton || control === checkoutWithoutButton) && getMerchandiseItems(currentCart).length === 0);
    });
    if (!busy) {
      updateRecommendationControls();
      if (addonModal && !addonModal.hidden) renderAddonVariant();
    }
    if (drawer) drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function announce(message, isError) {
    if (!statusNode) return;
    statusNode.textContent = message || '';
    statusNode.classList.toggle('is-error', Boolean(isError));
  }

  function renderItems(cart) {
    var items = getMerchandiseItems(cart);
    if (!itemsContainer) return;

    if (items.length === 0) {
      itemsContainer.innerHTML = '<p class="woodarq-cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    itemsContainer.innerHTML = items.map(function (item) {
      var image = item.image
        ? '<img class="woodarq-cart-item__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">'
        : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="woodarq-cart-item__variant">' + escapeHtml(item.variant_title) + '</span>'
        : '';

      return '' +
        '<article class="woodarq-cart-item" data-woodarq-cart-item-key="' + escapeHtml(item.key) + '">' +
          '<a class="woodarq-cart-item__image-link" href="' + escapeHtml(item.url || '#') + '">' + image + '</a>' +
          '<div class="woodarq-cart-item__details">' +
            '<a class="woodarq-cart-item__title" href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(item.product_title || item.title) + '</a>' +
            variantTitle +
          '</div>' +
          '<span class="woodarq-cart-item__price">' + formatMoney(item.final_line_price == null ? item.line_price : item.final_line_price) + '</span>' +
          '<div class="woodarq-cart-item__actions">' +
            '<div class="woodarq-cart-item__quantity" aria-label="Quantity for ' + escapeHtml(item.product_title || item.title) + '">' +
              '<button type="button" data-woodarq-cart-quantity="decrease" aria-label="Decrease quantity">−</button>' +
              '<span aria-live="polite">' + Number(item.quantity || 0) + '</span>' +
              '<button type="button" data-woodarq-cart-quantity="increase" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="woodarq-cart-item__remove" type="button" data-woodarq-cart-remove>Remove</button>' +
          '</div>' +
        '</article>';
    }).join('');
  }

  function collectRecommendations(cart) {
    var cartVariantIds = new Set((cart.items || []).map(function (item) {
      return String(item.variant_id);
    }));
    var seenProductIds = new Set();
    var recommendations = [];

    getMerchandiseItems(cart).forEach(function (item) {
      var sourceRecommendations = recommendationData.get(String(item.product_id)) || [];
      sourceRecommendations.forEach(function (recommendation) {
        var availableVariants = recommendation.variants.filter(function (variant) {
          return variant.id && variant.available;
        });
        var hasUncartedAvailableVariant = availableVariants.some(function (variant) {
          return !cartVariantIds.has(variant.id);
        });
        if (!recommendation.id || !hasUncartedAvailableVariant) return;
        if (seenProductIds.has(recommendation.id)) return;
        seenProductIds.add(recommendation.id);
        recommendations.push(recommendation);
      });
    });

    return recommendations;
  }

  function renderRecommendations(cart) {
    if (!recommendationsSection || !recommendationsTrack) return;
    var recommendations = collectRecommendations(cart);
    renderedRecommendations = new Map(recommendations.map(function (recommendation) {
      return [recommendation.id, recommendation];
    }));
    recommendationsSection.hidden = recommendations.length === 0;

    recommendationsTrack.innerHTML = recommendations.map(function (recommendation) {
      var image = recommendation.image
        ? '<img class="woodarq-cart-recommendation__image" src="' + escapeHtml(recommendation.image) + '" alt="' + escapeHtml(recommendation.title) + '" loading="lazy">'
        : '';
      var hasMultipleVariants = recommendation.variants.length > 1;
      var accessibleAction = hasMultipleVariants ? 'Choose options for ' : 'Add ';

      return '' +
        '<button class="woodarq-cart-recommendation" type="button" data-woodarq-cart-recommendation-product="' + escapeHtml(recommendation.id) + '" aria-label="' + accessibleAction + escapeHtml(recommendation.title) + '">' +
          '<span class="woodarq-cart-recommendation__image-wrap">' + image + '</span>' +
          '<span class="woodarq-cart-recommendation__title">' + escapeHtml(recommendation.title) + '</span>' +
        '</button>';
    }).join('');

    recommendationsTrack.scrollLeft = 0;

    window.requestAnimationFrame(updateRecommendationControls);
  }

  function renderProtection(cart) {
    var merchandiseItems = getMerchandiseItems(cart);
    var merchandiseSubtotal = getMerchandiseSubtotal(cart);
    var tier = getProtectionTier(merchandiseSubtotal);
    var activeItem = (cart.items || []).find(isProtectionItem);

    var offersProtection = Boolean(tier && tier.id && merchandiseItems.length);
    if (protectionRow) protectionRow.hidden = !offersProtection;
    if (checkoutWithoutButton) checkoutWithoutButton.hidden = !offersProtection;
    if (checkoutButton) checkoutButton.dataset.woodarqCartProtectedCheckout = offersProtection ? 'true' : 'false';
    if (checkoutLabel) checkoutLabel.textContent = offersProtection ? 'Protected checkout' : 'Checkout';
    if (checkoutLock) checkoutLock.toggleAttribute('hidden', !offersProtection);
    if (protectionPrice && offersProtection) {
      var displayedPrice = activeItem
        ? Number(activeItem.final_line_price == null ? activeItem.line_price : activeItem.final_line_price)
        : tier.price;
      protectionPrice.textContent = formatMoney(displayedPrice);
    }
  }

  function renderTotals(cart) {
    var count = getVisibleItemCount(cart);
    root.querySelectorAll('#mini-cart-item-count, [data-woodarq-cart-close-count]').forEach(function (node) {
      node.textContent = count;
    });

    var subtotal = root.querySelector('[data-woodarq-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var checkoutDisabled = checkingOut || busyCount > 0 || getMerchandiseItems(cart).length === 0;
    if (checkoutButton) checkoutButton.disabled = checkoutDisabled;
    if (checkoutWithoutButton) checkoutWithoutButton.disabled = checkoutDisabled;
  }

  function render(cart) {
    currentCart = cart;
    renderItems(cart);
    renderRecommendations(cart);
    renderProtection(cart);
    renderTotals(cart);
  }

  async function removeProtectionItems(cart) {
    var protectionItems = (cart.items || []).filter(isProtectionItem);
    var nextCart = cart;
    for (var index = 0; index < protectionItems.length; index += 1) {
      nextCart = await changeCartItem(protectionItems[index].key, 0);
    }
    return nextCart;
  }

  async function replaceProtection(cart, expectedVariantId) {
    var nextCart = await removeProtectionItems(cart);
    if (expectedVariantId) {
      await addCartVariant(expectedVariantId, { _woodarq_shipping_protection: 'true' });
      nextCart = await fetchCart();
    }
    return nextCart;
  }

  async function syncProtectionTier(cart) {
    var protectionItems = (cart.items || []).filter(isProtectionItem);
    if (protectionItems.length === 0) return cart;

    var merchandiseSubtotal = getMerchandiseSubtotal(cart);
    if (getMerchandiseItems(cart).length === 0) return removeProtectionItems(cart);

    var tier = getProtectionTier(merchandiseSubtotal);
    if (!tier || !tier.id) return removeProtectionItems(cart);
    if (hasCorrectProtection(cart, tier)) return cart;

    return replaceProtection(cart, tier.id);
  }

  function hasCorrectProtection(cart, tier) {
    var items = (cart.items || []).filter(isProtectionItem);
    return Boolean(tier && tier.id && items.length === 1 &&
      String(items[0].variant_id) === String(tier.id) && Number(items[0].quantity) === 1);
  }

  async function refresh(options) {
    if (checkingOut) return;
    options = options || {};
    reloadRecommendationsNext = reloadRecommendationsNext || Boolean(options.reloadRecommendations);

    if (refreshPromise) {
      refreshAgain = true;
      return refreshPromise;
    }

    refreshPromise = (async function () {
      do {
        refreshAgain = false;
        var shouldReloadRecommendations = reloadRecommendationsNext;
        reloadRecommendationsNext = false;

        var cart = await fetchCart();
        if (shouldReloadRecommendations) await loadRecommendationData();
        cart = await syncProtectionTier(cart);
        render(cart);
      } while (refreshAgain || reloadRecommendationsNext);
    })();

    try {
      await refreshPromise;
      announce('');
    } catch (error) {
      announce(error && error.message ? error.message : 'Unable to refresh the cart.', true);
    } finally {
      refreshPromise = null;
    }
  }

  function requestRefresh(reloadRecommendations) {
    if (checkingOut) return;
    reloadRecommendationsNext = reloadRecommendationsNext || Boolean(reloadRecommendations);
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refresh({ reloadRecommendations: reloadRecommendationsNext });
    }, 60);
  }

  async function runMutation(action, successMessage) {
    if (checkingOut || busyCount > 0) return false;
    setBusy(true);
    announce('');
    try {
      await action();
      await loadRecommendationData();
      var cart = await fetchCart();
      cart = await syncProtectionTier(cart);
      render(cart);
      if (successMessage) announce(successMessage);
      return true;
    } catch (error) {
      announce(error && error.message ? error.message : 'Unable to update the cart.', true);
      await refresh({ reloadRecommendations: true });
      return false;
    } finally {
      setBusy(false);
    }
  }

  async function checkout(withProtection) {
    if (checkingOut || busyCount > 0 || !checkoutForm) return;
    checkingOut = true;
    window.clearTimeout(refreshTimer);
    setBusy(true);
    announce('');
    if (checkoutError) {
      checkoutError.textContent = '';
      checkoutError.hidden = true;
    }

    var checkoutInput;
    try {
      // Finish earlier tier updates before applying either checkout choice.
      if (refreshPromise) await refreshPromise;
      if (withProtection) await loadProtectionProduct();
      var cart = await fetchCart();
      if (getMerchandiseItems(cart).length === 0) throw new Error('Your cart is empty. Add a product before checking out.');

      if (withProtection) {
        var tier = getProtectionTier(getMerchandiseSubtotal(cart));
        if (!tier || !tier.id) throw new Error('Package protection is unavailable. Please choose checkout without package protection.');
        if (!hasCorrectProtection(cart, tier)) await replaceProtection(cart, tier.id);
      } else {
        await removeProtectionItems(cart);
      }

      // Only proceed once the server cart confirms the customer's choice.
      cart = await fetchCart();
      if (getMerchandiseItems(cart).length === 0) throw new Error('Your cart is empty. Add a product before checking out.');
      var protectionMatches = withProtection
        ? hasCorrectProtection(cart, getProtectionTier(getMerchandiseSubtotal(cart)))
        : !(cart.items || []).some(isProtectionItem);
      if (!protectionMatches) throw new Error('Unable to confirm your package protection choice. Please try again.');
      render(cart);

      // Disabled buttons are excluded from a native form submission.
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      checkoutInput.setAttribute('data-woodarq-cart-checkout-submit', '');
      checkoutForm.appendChild(checkoutInput);
      HTMLFormElement.prototype.submit.call(checkoutForm);
    } catch (error) {
      if (checkoutInput) checkoutInput.remove();
      // Refresh without tier synchronization, so an opt-out cannot re-add protection.
      try { render(await fetchCart()); } catch (refreshError) { /* Keep the last rendered cart. */ }
      checkingOut = false;
      setBusy(false);
      var message = (error && error.message) || 'Unable to prepare checkout. Please try again.';
      if (checkoutError) {
        checkoutError.textContent = message;
        checkoutError.hidden = false;
      } else {
        announce(message, true);
      }
    }
  }

  function updateRecommendationControls() {
    if (!recommendationsTrack || !recommendationsPrevious || !recommendationsNext) return;
    var maximumScroll = Math.max(0, recommendationsTrack.scrollWidth - recommendationsTrack.clientWidth);
    recommendationsPrevious.disabled = recommendationsTrack.scrollLeft <= 2;
    recommendationsNext.disabled = recommendationsTrack.scrollLeft >= maximumScroll - 2 || maximumScroll === 0;
  }

  function scrollRecommendations(direction) {
    if (!recommendationsTrack) return;
    var card = recommendationsTrack.querySelector('.woodarq-cart-recommendation');
    var amount = card ? card.getBoundingClientRect().width + 10 : 114;
    recommendationsTrack.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function getSelectedAddonVariant() {
    if (!activeAddonProduct || !addonOptions) return null;
    var selectedOptions = Array.from(addonOptions.querySelectorAll('select')).map(function (select) {
      return select.value;
    });

    return activeAddonProduct.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    }) || null;
  }

  function renderAddonVariant() {
    activeAddonVariant = getSelectedAddonVariant();
    var available = Boolean(activeAddonVariant && activeAddonVariant.available);
    var image = activeAddonVariant && activeAddonVariant.image
      ? activeAddonVariant.image
      : activeAddonProduct && activeAddonProduct.image;

    if (addonImageWrap) {
      addonImageWrap.innerHTML = image
        ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(activeAddonProduct.title) + '">'
        : '';
    }
    if (addonPrice) addonPrice.textContent = activeAddonVariant ? formatMoney(activeAddonVariant.price) : '';
    if (addonSubmit) {
      addonSubmit.disabled = !available;
      addonSubmit.textContent = available ? 'Add to cart' : 'Unavailable';
    }
    if (addonAvailability) {
      addonAvailability.textContent = activeAddonVariant && !available
        ? 'This combination is currently unavailable.'
        : '';
    }
  }

  function closeAddonModal(options) {
    options = options || {};
    if (!addonModal || addonModal.hidden) return;
    addonModal.hidden = true;
    addonModal.setAttribute('aria-hidden', 'true');
    activeAddonProduct = null;
    activeAddonVariant = null;

    if (options.returnFocus !== false && addonReturnFocus && document.documentElement.contains(addonReturnFocus)) {
      addonReturnFocus.focus({ preventScroll: true });
    }
    addonReturnFocus = null;
  }

  function openAddonModal(product, opener) {
    if (!addonModal || !addonOptions || !product) return;
    activeAddonProduct = product;
    addonReturnFocus = opener || null;
    if (addonTitle) addonTitle.textContent = product.title;
    if (addonQuantity) addonQuantity.value = '1';

    var cartVariantIds = new Set((currentCart && currentCart.items ? currentCart.items : []).map(function (item) {
      return String(item.variant_id);
    }));
    var firstAvailableVariant = product.variants.find(function (variant) {
      return variant.available && !cartVariantIds.has(variant.id);
    }) || product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];

    addonOptions.innerHTML = product.options.map(function (option, optionIndex) {
      var selectedValue = firstAvailableVariant && firstAvailableVariant.options[optionIndex];
      var values = (Array.isArray(option.values) ? option.values : []).map(function (value) {
        return '<option value="' + escapeHtml(value) + '"' + (value === selectedValue ? ' selected' : '') + '>' + escapeHtml(value) + '</option>';
      }).join('');
      return '<label><span>' + escapeHtml(option.name) + '</span><select data-woodarq-cart-addon-option="' + optionIndex + '">' + values + '</select></label>';
    }).join('');

    addonModal.hidden = false;
    addonModal.setAttribute('aria-hidden', 'false');
    renderAddonVariant();
    var firstSelect = addonOptions.querySelector('select');
    window.setTimeout(function () {
      (firstSelect || addonModal.querySelector('[data-woodarq-cart-addon-close]')).focus({ preventScroll: true });
    }, 0);
  }

  function trapAddonModalFocus(event) {
    if (!addonModal || addonModal.hidden || event.key !== 'Tab') return;
    var focusable = Array.from(addonModal.querySelectorAll('button:not(:disabled), select:not(:disabled), input:not(:disabled)'));
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function lockPageScroll() {
    if (lockedScrollY !== null) return;

    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    previousBodyTop = document.body.style.top;
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.documentElement.classList.add('woodarq-mini-cart-open');
    document.body.classList.add('woodarq-mini-cart-open');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('woodarq-mini-cart-open');
    document.body.classList.remove('woodarq-mini-cart-open');
    if (lockedScrollY === null) return;

    var scrollY = lockedScrollY;
    document.body.style.top = previousBodyTop;
    lockedScrollY = null;
    previousBodyTop = '';
    window.scrollTo(0, scrollY);
  }

  function containCartScroll(event) {
    if (!drawer || !drawer.classList.contains('mini-cart_active')) return;
    if (addonModal && !addonModal.hidden && addonModal.contains(event.target)) return;

    var isInsideDrawer = drawer.contains(event.target);
    if (!isInsideDrawer && event.cancelable) event.preventDefault();
    event.stopPropagation();
  }

  function containCartScrollKeys(event) {
    if (!drawer || !drawer.classList.contains('mini-cart_active')) return;
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(event.key) === -1) return;
    event.stopPropagation();
  }

  function syncOpenState() {
    if (!drawer) return;
    var isOpen = drawer.classList.contains('mini-cart_active');
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (backdrop) backdrop.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) lockPageScroll();
    else unlockPageScroll();

    if (isOpen && !wasOpen) {
      requestRefresh(true);
      window.setTimeout(function () {
        if (closeButton) closeButton.focus({ preventScroll: true });
      }, 0);
    } else if (!isOpen && wasOpen && trigger) {
      trigger.focus({ preventScroll: true });
    }

    wasOpen = isOpen;
  }

  function closeDrawer() {
    closeAddonModal({ returnFocus: false });
    var instance = window.miniCartInstance;
    if (instance && instance.cartActive && typeof instance.toggleCart === 'function') {
      instance.toggleCart();
      return;
    }

    if (drawer) drawer.classList.remove('mini-cart_active');
    if (backdrop) backdrop.classList.remove('mini-cart-global-backdrop_active');
    syncOpenState();
  }

  function installFetchObserver(callback) {
    if (!window.__woodarqCartFetchObserver) {
      var originalFetch = window.fetch.bind(window);
      var subscribers = new Set();

      window.fetch = async function (input, init) {
        var response = await originalFetch(input, init);

        try {
          var requestUrl = typeof input === 'string' ? input : input.url;
          var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
          var requestHeaders = new Headers((init && init.headers) || (input && input.headers) || {});
          var pathname = new URL(requestUrl, window.location.origin).pathname;
          var isCartMutation = method !== 'GET' && /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(pathname);
          var isInternalMutation = requestHeaders.get('X-Woodarq-Cart-Drawer') === '1';

          if (response.ok && isCartMutation && !isInternalMutation) {
            window.setTimeout(function () {
              subscribers.forEach(function (subscriber) {
                subscriber();
              });
            }, 30);
          }
        } catch (error) {
          // A third-party request might not expose a URL. It is unrelated to the cart.
        }

        return response;
      };

      window.__woodarqCartFetchObserver = { subscribers: subscribers };
    }

    window.__woodarqCartFetchObserver.subscribers.add(callback);
  }

  root.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-woodarq-cart-quantity]');
    if (quantityButton) {
      var itemElement = quantityButton.closest('[data-woodarq-cart-item-key]');
      var itemKey = itemElement && itemElement.dataset.woodarqCartItemKey;
      var item = currentCart && currentCart.items.find(function (candidate) {
        return candidate.key === itemKey;
      });
      if (!item) return;

      var difference = quantityButton.dataset.woodarqCartQuantity === 'increase' ? 1 : -1;
      var nextQuantity = Math.max(0, Number(item.quantity || 0) + difference);
      runMutation(function () {
        return changeCartItem(item.key, nextQuantity);
      });
      return;
    }

    var removeButton = event.target.closest('[data-woodarq-cart-remove]');
    if (removeButton) {
      var removeItemElement = removeButton.closest('[data-woodarq-cart-item-key]');
      var removeItemKey = removeItemElement && removeItemElement.dataset.woodarqCartItemKey;
      if (removeItemKey) {
        runMutation(function () {
          return changeCartItem(removeItemKey, 0);
        }, 'Item removed.');
      }
      return;
    }

    var addButton = event.target.closest('[data-woodarq-cart-recommendation-product]');
    if (addButton) {
      var recommendation = renderedRecommendations.get(addButton.dataset.woodarqCartRecommendationProduct);
      if (!recommendation) return;
      if (recommendation.variants.length === 1) {
        runMutation(function () {
          return addCartVariant(recommendation.variants[0].id);
        }, 'Add-on added.');
      } else {
        openAddonModal(recommendation, addButton);
      }
      return;
    }

    if (event.target.closest('[data-woodarq-cart-addon-close]')) {
      closeAddonModal();
      return;
    }

    if (event.target.closest('[data-woodarq-cart-recommendations-previous]')) {
      scrollRecommendations(-1);
      return;
    }

    if (event.target.closest('[data-woodarq-cart-recommendations-next]')) {
      scrollRecommendations(1);
    }
  });

  if (addonOptions) addonOptions.addEventListener('change', renderAddonVariant);

  if (addonForm) {
    addonForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!activeAddonVariant || !activeAddonVariant.available) return;
      var quantity = Math.max(1, Number(addonQuantity && addonQuantity.value) || 1);
      var added = await runMutation(function () {
        return addCartVariant(activeAddonVariant.id, null, quantity);
      }, 'Add-on added.');
      if (added) closeAddonModal({ returnFocus: false });
    });
  }

  if (checkoutForm) {
    checkoutForm.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      checkout(event.submitter !== checkoutWithoutButton && checkoutButton.dataset.woodarqCartProtectedCheckout === 'true');
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !checkingOut) return;
    checkingOut = false;
    var checkoutInput = checkoutForm.querySelector('[data-woodarq-cart-checkout-submit]');
    if (checkoutInput) checkoutInput.remove();
    setBusy(false);
    requestRefresh(true);
  });

  if (recommendationsTrack) recommendationsTrack.addEventListener('scroll', updateRecommendationControls, { passive: true });
  window.addEventListener('resize', updateRecommendationControls);

  root.addEventListener('wheel', containCartScroll, { passive: false });
  root.addEventListener('touchmove', containCartScroll, { passive: false });
  root.addEventListener('keydown', containCartScrollKeys);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && addonModal && !addonModal.hidden) {
      event.preventDefault();
      closeAddonModal();
    } else if (event.key === 'Escape' && drawer && drawer.classList.contains('mini-cart_active')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  if (addonModal) addonModal.addEventListener('keydown', trapAddonModalFocus);

  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(syncOpenState).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('cart:change', function () { requestRefresh(true); });
  document.addEventListener('cart:updated', function () { requestRefresh(true); });
  document.addEventListener('cart:refresh', function () { requestRefresh(true); });

  installFetchObserver(function () {
    requestRefresh(true);
  });

  syncOpenState();
  refresh();
})();
